// extracted by mini-css-extract-plugin
export default {"container":"articles_container__1V-6s","items":"articles_items__31LFP","articleWrapper":"articles_articleWrapper__1EcqP"};